<template>
<div class="archive">
  <div class="feature" v-if="currentArtist">
    <router-link tag="div" class="image" :style="`background-image: url('${$options.filters.imgix(currentArtist.program_image || currentArtist.feature_image)}')`" :to="`/program/artist/${currentArtist.slug}`"></router-link>
  </div>

  <div class="header">
    <h2 class="size-large">Program Archive</h2>
  </div>

  <div class="sort-controls size-small">
    <div class="dropdown">
      <a href="#" :class="{active:sort.field=='num'}" @click.prevent="sort.field = 'num'">Week</a>
      <a href="#" :class="{active:sort.field=='title'}" @click.prevent="sort.field = 'title'">Artist</a>
      <a href="#" :class="{active:sort.field=='country'}" @click.prevent="sort.field = 'country'">Country</a>
    </div>
    <div class="direction" @click.prevent="sort.reverse = !sort.reverse">
      <img class="arrow" :class="{flip:sort.reverse}" src="/static/images/arrow.svg" />
    </div>
  </div>

  <transition-group class="list" name="list">
    <router-link class="card" :class="{hidden:artist.hidden,current:artist.num===currentArtist.num}" v-for="(artist, n) in sortedArtists" :key="artist.slug" :to="`/program/artist/${artist.slug}`" :event="artist.hidden ? '' : 'click'">
      <div v-if="artist.num === currentArtist.num" class="current-tag">
        Current artist
      </div>
      <div class="image">
        <svg v-if="artist.hidden" class="screen" width="100%" height="100%">
          <pattern id="pattern" width="6" height="1" patternUnits="userSpaceOnUse">
            <rect x="0" y="0" width="2" height="1" />
          </pattern>

          <rect fill="url(#pattern)" width="100%" height="100%" />
        </svg> 

        <img v-if="artist.profile_image" :src="$options.filters.imgix(artist.feature_image, { h: 480 })" />
      </div>
      <div class="detail">
        <div v-if="sort.field === 'num'">
          <div class="number big size-large">{{artist.num|pad}}</div>
          <div class="title">
            {{artist.title}},
            <span v-if="artist.city">{{artist.city}},</span> {{artist.country}}
          </div>
        </div>
        <div v-if="sort.field === 'title'">
          <div class="title big size-large">{{artist.title}}</div>
          <div><span v-if="artist.city">{{artist.city}},</span> {{artist.country}}, {{artist.num|pad}}</div>
        </div>
        <div v-if="sort.field === 'country'">
          <div class="title big size-large">{{artist.country}}</div>
          <div>{{artist.title}}, {{artist.num|pad}}</div>
        </div>
      </div>
    </router-link>
  </transition-group>
</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default Vue.component('RouteProgram', {
  data: () => ({
    sort: {
      field: 'num',
      reverse: false
    }
  }),
  computed: {
    ...mapGetters('artists', ['artists', 'currentArtist', 'programFeaturedArtist']),
    sortedArtists() {
      if(!this.artists) return

      let sortedArtists = this.artists

      if(this.sort.field) sortedArtists = _.sortBy(sortedArtists, this.sort.field)
      if(this.sort.reverse) sortedArtists = _.reverse(sortedArtists)

      return sortedArtists
    }
  }
})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';

.feature {
  height: 100vh;
  cursor: pointer;
  position: relative;
  .image {
    width: 100vw;
    height: 100vh;
    background-size: initial;
    background-repeat: repeat;
  }
}

.archive {
  background: $color-white;
  color: $color-black;
  min-height: 100vh;
  .header {
    padding: $gutter;
    padding-top: 9.6rem;
    h2 {
      text-transform: uppercase;
      margin-bottom: 2.4rem;
    }
    p {
      max-width: 56rem;
      line-height: 1.4;
    }
  }

  .list-move {
    transition: transform 1s;
    transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    .card {
      background: $color-white;
      width: calc(100% * 1 / 5);
      @media (max-width: $break-huge) {
        width: calc(100% * 1 / 4);
      }
      @media (max-width: $break-large) {
        width: calc(100% * 1 / 3);
      }
      @media (max-width: $break-medium) {
        width: calc(100% * 1 / 2);
      }
      margin-bottom: 4.8rem;
      position: relative;
      &:hover .screen {
        animation-play-state: running!important;
      }
      &:hover, &.current {
        color: $color-blue;
      }
      .current-tag {
        background: $color-blue;
        color: $color-white;
        font-family: $font-mono;
        font-weight: normal;
        text-transform: uppercase;
        position: absolute;
        top: 0; left: 0;
        z-index: 2;
        margin: 0.5rem;
        padding: 0.5rem 0.8rem 0.4rem;
      }
      &.hidden {
        cursor: default;
        &:hover {
          color: inherit;
        }
        .image {
          filter: grayscale(1);
        }
      }
      .image {
        width: 100%;
        background-image: $color-gray;
        position: relative;
        img {
          width: 100%;
        }
        .screen {
          position: absolute;
          top: 0; left: 0;
          animation-name: move;
          animation-duration: 0.2s;
          animation-iteration-count: infinite;
          animation-fill-mode: forwards;
          animation-timing-function: linear;
          animation-play-state: paused;
          pattern rect {
            fill: $color-white;
          }
        }
      }
      .detail {
        padding: 0.5rem;
        text-transform: uppercase;
      }
      .big {
        line-height: 1;
        margin-bottom: 0.1em;
        word-break: break-word;
        hyphens: auto;
      }
    }
  }
}

@keyframes move {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(6px);
  }
}

.sort-controls {
  display: flex;
  font-family: $font-mono;
  font-weight: normal;
  text-transform: uppercase;
  margin: $gutter;
  justify-content: space-between;
  .dropdown, .direction {
    padding: 1.1rem 1.4rem;
  }
  .dropdown {
    color: $color-white;
    background: $color-black;
    a {
      margin: 0 0.3rem;
      &.active {
        border-bottom: 2px solid;
      }
    }
  }
  .direction {
    background: $color-black;
    color: $color-white;
    cursor: pointer;
    &:hover {
      background: $color-red;
    }
    .arrow {
      display: block;
      transform-origin: center;
      transition: transform 0.5s;
      width: 1em;
      filter: invert(1);
      margin-top: 0.2rem;
      &.flip {
        transform: rotate(-180deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/routes/route-program.vue